<template>
  <section class="section-confirm-professional-booking p-4">
    <!-- Navigation -->
    <div class="row mb-3">
      <div class="col-12 col-md-8 offset-md-2">
        <router-link :to="(isLineLoggedIn) ? '/line-liff/bookings' : '/my-reservations'" class="text-primary-link">{{ $t('message.menu.my_reservations') }}</router-link>
        <i class="fal fa-angle-right"></i>
        <router-link class="text-primary-link" :to="`/service-requests/${serviceRequest.id}`">
          {{ $t('message.my_reservations.service_request_detail') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        {{ $t('message.my_reservations.payment') }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6 offset-lg-3">
        <loader v-if="!serviceRequest"></loader>
        <div v-if="serviceRequest && order">
          <!-- Payment type -->
          <div class="card shadow-sm">
            <div class="card-body text-left pb-2">
              #{{ order.code }} - <span
              v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span>
              <div class="row no-gutters pt-3">
                <div class="col-6">
                  <label>{{ $t('message.service_request.service_cost') }}</label>
                </div>
                <div class="col-6 text-right">
                  <label>{{ serviceRequest.service_cost | currency }}</label>
                </div>
              </div>
            </div>

            <div class="card-body">
              <section v-if="serviceRequest.promotion_cost">
                <div class="radio" v-if="serviceRequest.payment_status === 0">
                  <label class="custom-inline">
                <span
                  class="label-span">{{ $t('message.service_request.service_request_payment_pay_promotion') }}</span>
                    <input type="radio" name="type_payment" required
                           v-model="paymentType"
                           value="promotion">
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="radio" v-if="serviceRequest.payment_status === 3">
                  <label class="custom-inline">
                    <span
                      class="label-span">{{ $t('message.service_request.service_request_payment_pay_total') }}</span>
                    <input type="radio" name="type_payment" required
                           v-model="paymentType"
                           value="full">
                    <span class="checkmark"></span>
                  </label>
                </div>
                <hr v-if="serviceRequest.payment_status === 3">
                <div class="radio" v-if="hasPaidServiceRequestCost(serviceRequest, 'promotion')">
                  <label class="custom-inline">
                  <span class="label-span">
                    {{ serviceRequest && serviceRequest.payment_status === 1 ? $t('message.service_request.service_request_payment_pay_remaining') : $t('message.service_request.service_request_payment_pay_deposit') }}
                    <span class="text-remark" v-if="serviceRequest.payment_status === 3">
                      <br>{{ $t('message.service_request.service_request_payment_pay_remaining_balance_remark') }}
                    </span>
                  </span>
                    <input type="radio" name="type_payment"
                           v-model="paymentType" :required="serviceRequest.payment_status === 1"
                           value="deposit">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </section>

              <section v-else>
                <div class="radio" v-if="serviceRequest.payment_status === 0">
                  <label class="custom-inline" for="type_payment1">
                    <span
                      class="label-span">{{ $t('message.service_request.service_request_payment_pay_total') }}</span>
                    <input type="radio" name="type_payment" required
                           v-model="paymentType"
                           id="type_payment1" value="full">
                    <span class="checkmark"></span>
                  </label>
                </div>
                <hr v-if="serviceRequest.payment_status === 0">
                <div class="radio">
                  <label class="custom-inline" for="type_payment2">
                              <span class="label-span">
                                {{ serviceRequest && serviceRequest.payment_status === 1 ? $t('message.service_request.service_request_payment_pay_remaining') : $t('message.service_request.service_request_payment_pay_deposit') }}
                                <span class="text-remark" v-if="serviceRequest.payment_status === 0">
                                  <br>{{ $t('message.service_request.service_request_payment_pay_remaining_balance_remark') }}
                                </span>
                              </span>
                    <input type="radio" name="type_payment"
                           v-model="paymentType" :required="serviceRequest.payment_status === 1"
                           id="type_payment2" value="deposit">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </section>

              <template v-if="calculateServiceCost">
                <hr>
                <div class="row no-gutters footer">
                  <div class="col-6 text-left">
                    <strong>{{ $t('message.service_request.all_amount_due') }}</strong>
                  </div>
                  <div class="col-6 text-right">
                    <strong v-if="paymentType">{{ calculateServiceCost | currency }}</strong>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- Payment method -->
          <div class="pt-3" v-if="paymentType">
            <payment-methods ref="paymentMethods"
                             :displayPromptpay="false"
                             @onSelectedPaymentMethod="updatePaymentMethod"
                             @onSelectedCreditCard="applyUserCreditCard"
                             @onRequestedSavingTempData="saveTempData"
                             @onSelectedFileUpload="setFileUpload"
                             @onSuccessQrPayment="displaySuccessDialog"></payment-methods>
          </div>

          <div class="row no-gutters px-2 d-flex h-100 pt-4" v-if="paymentType && paymentMethod">
            <div class="col-6 text-left align-self-center">
              <h3 class="-status-new m-0">
                <strong>{{ calculateServiceCost | currency }}</strong>
              </h3>
              <span>{{ $t('message.service_request.all_vat_included') }}</span>
            </div>
            <div class="col-6 text-right align-self-center">
              <button class="btn btn-info btn-lg"
                      :disabled="isLoading"
                      @click="submitPayment()">
                {{ (isLoading) ? $t('message.processing') : $t('message.button.confirm_payment') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Back navigation for line liff -->
    <div class="container text-center py-2" v-if="isLineLoggedIn">
      <router-link :to="`/service-requests/${serviceRequest.id}`">
        <i class="fas fa-angle-left"></i> {{ $t('message.booking.new_booking.back') }}
      </router-link>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapState } from 'vuex'
  import Loader from '../loader/Loader'
  import PaymentMethods from '../order/PaymentMethods'
  import { orderMixin } from '../../mixins/orderMixin'

  export default {
    mixins: [orderMixin],
    components: {
      Loader,
      PaymentMethods
    },
    data () {
      return {
        order: null,
        serviceRequest: null,
        paymentType: null,
        paymentMethod: null,
        omiseCustomerId: null,
        fileUpload: null,
        isLoading: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      ...mapState('auth', ['isLineLoggedIn']),
      ...mapState('serviceRequest', ['tmpServiceRequestPaymentData']),
      calculateServiceCost () {
        let totalCost = null
        if (this.serviceRequest) {
          const paymentType = this.paymentType
          const hasPaidPromotionCost = this.hasPaidServiceRequestCost(this.serviceRequest, 'promotion')
          const hasPaidDepositCost = this.hasPaidServiceRequestCost(this.serviceRequest, 'deposit')
          const promotionCost = this.serviceRequest.promotion_cost
          switch (paymentType) {
            case 'full':
              totalCost = this.serviceRequest.service_cost
              if (promotionCost != null && hasPaidPromotionCost) {
                totalCost = totalCost - promotionCost
              }
              break
            case 'deposit':
              totalCost = parseFloat((this.serviceRequest.service_cost / 2)).toFixed(2)
              if (promotionCost != null && hasPaidPromotionCost && !hasPaidDepositCost) {
                totalCost = totalCost - promotionCost
              }
              break
            case 'promotion':
              totalCost = this.serviceRequest.promotion_cost
              break
          }
        }
        return totalCost
      }
    },
    methods: {
      hasPaidServiceRequestCost (serviceRequest, paymentType) {
        let hasPaid = false
        const serviceRequestPayments = serviceRequest.service_request_payments
        if (serviceRequestPayments.length > 0) {
          for (const serviceRequestPayment of serviceRequestPayments) {
            if (serviceRequestPayment.payment_type === paymentType) {
              hasPaid = true
              break
            }
          }
        }
        return hasPaid
      },
      submitPayment () {
        if (this.paymentMethod) {
          switch (this.paymentMethod) {
            case 'credit_card':
              if (!this.omiseCustomerId) {
                this.$swal({text: this.$i18n.t('message.alert.select_credit_card')})
              } else {
                this.addServiceRequestPayment()
              }
              break
            case 'bank_transfer':
              if (!this.fileUpload) {
                const alertMessage = this.$i18n.t('message.alert.no_file_upload')
                this.$swal({text: alertMessage, type: 'error'})
              } else {
                this.addServiceRequestPayment()
              }
              break
          }
        } else {
          this.$swal({text: this.$i18n.t('message.alert.select_payment_method')})
        }
      },
      async addServiceRequestPayment () {
        this.isLoading = true
        let formData = new FormData()
        formData.append('id', this.serviceRequest.id)
        formData.append('user_id', this.serviceRequest.user_id)
        formData.append('service_request_id', this.serviceRequest.id)
        formData.append('payment_type', this.paymentType)
        formData.append('payment_method', this.paymentMethod)
        if (this.paymentMethod === 'credit_card') {
          formData.append('omise_customer_id', this.omiseCustomerId)
        } else if (this.paymentMethod === 'bank_transfer') {
          formData.append('slip_image', this.fileUpload)
        }
        const url = `/service-requests/${this.serviceRequest.id}/payment`
        let {data} = await axios.post(url, formData)
        this.isLoading = false
        if (!data.error) {
          this.displaySuccessDialog()
        } else {
          this.$swal({text: 'Error: ' + data.message, type: 'error'})
        }
      },
      async getServiceRequest () {
        const serviceRequestId = Number(this.$route.params.id)
        const url = `/service-requests/${serviceRequestId}`
        let {data} = await axios.get(url)
        if (!data.error) {
          this.serviceRequest = data.service_request
          this.order = data.order
        } else {
          this.$swal({text: 'ผิดพลาด ' + data.message, type: 'error'})
        }
      },
      updatePaymentMethod (paymentMethod) {
        this.paymentMethod = paymentMethod
      },
      applyUserCreditCard (data) {
        this.paymentMethod = data.payment_method
        this.omiseCustomerId = data.omise_customer_id
      },
      saveTempData () {
        // Set temp service request payment data
        const serviceRequestPaymentData = {
          payment_type: this.paymentType,
          payment_method: this.paymentMethod
        }
        this.$store.commit('serviceRequest/SET_TMP_SERVICE_REQUEST_PAYMENT_DATA', serviceRequestPaymentData)
      },
      setFileUpload (file) {
        this.fileUpload = file
      },
      displaySuccessDialog (alertMessage = this.$i18n.t('message.payment_method.payment_success')) {
        if (this.tmpServiceRequestPaymentData) {
          this.$store.commit('serviceRequest/SET_TMP_SERVICE_REQUEST_PAYMENT_DATA', null)
        }
        this.$swal({
          text: alertMessage,
          type: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.button.close')
        }).then((result) => {
          if (result) {
            this.$router.push(`/service-requests/${this.serviceRequest.id}`)
          }
        })
      }
    },
    async mounted () {
      await this.getServiceRequest()
      // Check temp booking from adding new card
      if (this.tmpServiceRequestPaymentData) {
        this.paymentType = this.tmpServiceRequestPaymentData.payment_type
        setTimeout(() => {
          this.paymentMethod = this.tmpServiceRequestPaymentData.payment_method
          this.$refs.paymentMethods.setPaymentMethod(this.paymentMethod)
        }, 500)
      }
    }
  }
</script>

<style scoped lang="scss">

  .footer {
    font-weight: bold;
  }

  .box-body {
    color: black;
  }

  /* The container */
  .custom-inline {
    display: block;
    position: relative;
    padding-left: 0;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: left;

    input {
      position: absolute;
      right: 0;
      opacity: 0;
      cursor: pointer;
    }
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    right: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .custom-inline:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .custom-inline input:checked ~ .checkmark {
    background-color: #2196F3;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .custom-inline input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .custom-inline .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/ServiceRequestPayment.vue